import type { SEOPropsType } from '..';

export const SEO_TRETINOIN_CONTENT: SEOPropsType = {
  title: 'Tretinoin Prescription - Curology Custom Formula',
  description:
    'Tretinoin is a topical, prescription-only vitamin A derivative. It’s the gold standard for both acne and anti-aging. Find out if tretinoin is right for you.',
  isIndexableOverride: true,
};
